import { Card, CardBody, Col } from "reactstrap";
import { SalesSummarys } from "../../../Constant";
import CommonToggleHeader from "./Common/CommonToggleHeader";
import ReactApexChart from "react-apexcharts";
import { SALE_SUMMARY_DATA } from "../../../Data/Dashboard";

const SalesSummary = () => {
  return (
    <Col xxl="6" xl="5" md="6"  sm="12" className="box-col-4e">
      <Card>
        <CommonToggleHeader title={SalesSummarys} />
        <CardBody className="pt-0 pb-0">
          <div id="salessummary">
          <ReactApexChart options={SALE_SUMMARY_DATA} series={SALE_SUMMARY_DATA.series} type="bar" height={320} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SalesSummary;
